import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { RequestWaterSamplingAct } from "../models/request/request-water-sampling/request-water-sampling-act";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { LaboratoryCertificateRequiringDto } from "../models/laboratory/laboratory-certificate-requirings.dto";

@Injectable()
export class RequestWaterSamplingActsService extends DataService<RequestWaterSamplingAct, RequestWaterSamplingAct> {
    
    constructor(
        protected http: HttpClient,
        protected notificationService: NotificationService) {
        super(http, notificationService);

        this.controllerName = 'request-water-sampling-acts';
    }

    getByRequest(requestId: number): Observable<RequestWaterSamplingAct> {
        return this.getQuery<RequestWaterSamplingAct>(`${this.baseUrl()}/by-request/${requestId}`);
    }

    createByRequestWaterSampling(requestId: number) {
        return this.postQuery(`${this.baseUrl()}`, { requestId: requestId });
    }

    getLaboratoryCertificateRequiring(requestId: number): Observable<LaboratoryCertificateRequiringDto> {
        return this.getQuery<LaboratoryCertificateRequiringDto>(`${this.baseUrl()}/laboratory-certificate-requiring/${requestId}`)
    }
}